<div class="chart-loading">
  <app-icon title="Loading" [size]="IconSize.MEDIUM" className="icon--loading"
    >refresh</app-icon
  >
  <p>Loading</p>
</div>
